import { AccessTokenData } from '@types'
import API from 'core/api'
import { UserTokenInformation } from 'core/api/types'
import {
  getCookie,
  setAccessToken,
  setAge,
  setCookie,
  setGender,
  setMemberId,
  setMemberType,
} from 'core/singleton'

export class TokenWebLib {
  private partnerId: string
  private memberId: string
  private accessToken: string
  private memberType: string
  private age: string
  private gender: string
  private originToken: string | null = null
  private isValidation = false

  constructor({ partnerId, accessToken }: { partnerId: string; accessToken?: string }) {
    this.partnerId = partnerId
    this.accessToken = accessToken ?? ''
    this.memberId = ''
    this.memberType = ''
    this.age = 'etc'
    this.gender = 'e'
  }

  public setParsedLocalData() {
    const localToken = localStorage.getItem(
      this.partnerId ? `sauce_collect_accessToken_${this.partnerId}` : 'sauce_collect_accessToken',
    )
    if (!localToken) return
    const parsedTokenData: AccessTokenData = JSON.parse(localToken)
    this.accessToken = parsedTokenData.accessToken ? parsedTokenData.accessToken : ''
    this.memberType = '0'
    this.memberId = parsedTokenData.memberId ? parsedTokenData.memberId : ''
  }

  public async preload() {
    if (!this.accessToken || this.accessToken === 'undefined' || this.accessToken === 'logout') {
      try {
        const tokenArg = {
          age: 'etc',
          gender: 'e',
          memberType: '0',
          nickName: `GUEST${Math.floor(Math.random() * Math.pow(10, 10))}`,
          partnerId: this.partnerId ?? 'GUEST',
        }
        const token = await API.getCustomToken(tokenArg)
        this.memberId = token.memberId
        this.accessToken = token.accessToken
        this.memberType = token.memberType.toString()
        this.age = token.age
        this.gender = token.gender
      } catch (error) {
        throw new Error('token API error')
      }

      this.pending()

      setAccessToken(this.accessToken)
      setMemberId(this.memberId)
      setMemberType(this.memberType)
      setAge(this.age)
      setGender(this.gender)
    } else {
      try {
        const token = await API.getValidationToken(this.accessToken)
        this.memberId = token.memberId
        this.accessToken = token.accessToken
        this.memberType = token.memberType.toString()
      } catch (error) {
        const tokenArg = {
          age: 'etc',
          gender: 'e',
          memberType: '0',
          nickName: `GUEST${Math.floor(Math.random() * Math.pow(10, 10))}`,
          partnerId: this.partnerId ?? 'GUEST',
        }
        const token = await API.getCustomToken(tokenArg)
        this.memberId = token.memberId
        this.accessToken = token.accessToken
        this.memberType = token.memberType.toString()
        this.age = token.age
        this.gender = token.gender
      }

      this.pending()

      setAccessToken(this.accessToken)
      setMemberId(this.memberId)
      setMemberType(this.memberType)
      setAge(this.age)
      setGender(this.gender)
    }
  }

  async setMemberObject(arg: UserTokenInformation) {
    const token = getCookie(`collectToken_${this.partnerId}`)
    const memberToken = getCookie(`collectMember`)
    if (token && memberToken === arg.memberId) return
    try {
      const tokenArg = {
        ...arg,
        gender: arg.gender ?? 'e',
        age: arg.age ?? 'etc',
        partnerId: this.partnerId ?? '',
        memberType: '1',
      }
      const res = await API.getCustomToken(tokenArg)
      const defaultExpires = new Date()
      defaultExpires.setDate(defaultExpires.getDate() + 1)
      setCookie(`collectToken_${this.partnerId}`, res.accessToken, defaultExpires)
      setCookie(`collectMemberId`, this.memberId ?? res.memberId, defaultExpires)
      this.accessToken = res ? res.accessToken : ''
      return res.accessToken
    } catch (error) {
      const res = await API.getGuestToken()
      this.accessToken = res ? res.accessToken : ''
      this.age = res?.age || 'etc'
      this.gender = res?.gender || 'e'
    }

    this.pending()

    setAccessToken(this.accessToken)
    setMemberId(this.memberId)
    setMemberType(this.memberType)
    setAge(this.age)
    setGender(this.gender)
  }

  private async pending() {
    return await new Promise((resolve) => {
      const checkMemberId = () => {
        if (this.memberId) {
          resolve(1)
        } else {
          setTimeout(checkMemberId, 100)
        }
      }
      checkMemberId()
    })
  }

  async pendingValidation() {
    return await new Promise((resolve) => {
      const checkValidation = () => {
        if (this.isValidation) {
          resolve(1)
        } else {
          setTimeout(checkValidation, 100)
        }
      }
      checkValidation()
    })
  }

  async setMemberToken(token: string) {
    this.accessToken = token
    await this.preload()
  }
  async setOriginToken(originToken: string) {
    this.originToken = originToken
    try {
      const token = await API.getValidationToken(originToken)
      this.memberId = token.memberId
      this.accessToken = token.accessToken
      this.memberType = token.memberType.toString()
    } catch (error) {
      const tokenArg = {
        age: 'etc',
        gender: 'e',
        memberType: '0',
        nickName: `GUEST${Math.floor(Math.random() * Math.pow(10, 10))}`,
        partnerId: this.partnerId ?? 'GUEST',
      }
      const token = await API.getCustomToken(tokenArg)
      this.memberId = token.memberId
      this.accessToken = token.accessToken
      this.memberType = token.memberType.toString()
      this.age = token.age
      this.gender = token.gender
    }

    await this.pending()

    setAccessToken(this.accessToken)
    setMemberId(this.memberId)
    setMemberType(this.memberType)
    setAge(this.age)
    setGender(this.gender)

    this.isValidation = true
  }

  getAccessToken() {
    return this.accessToken
  }

  getMemberId() {
    return this.memberId
  }

  getMemberType() {
    return this.memberType
  }

  getAge() {
    return this.age
  }

  getOriginToken() {
    return this.originToken
  }
}
